import { inject, NgModule, provideAppInitializer } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule, Routes } from "@angular/router";
import { liveLessonModeratorFeatureShellRoutes } from "./lib.routes";
import { LiveLessonSharedFeatureShellModule } from "live-lesson/shared/feature-shell";
import { RoomsComponent } from "./rooms";
import { AuthGuardService } from "@pcp/auth";
import { VideoPlayerConfigService } from "@pcp/streaming";
import { EffectsModule } from "@ngrx/effects";
import { LiveLessonModeratorAuthEffects } from "./effects/live-lesson-moderator-auth.effects";

// TODO: lazy-loading of the module is not working yet.
//       Currently, all routes are defined inside the AppModule / AppRoutingModule.
const routes: Routes = [
    {
        path: "room/:groupId",
        component: RoomsComponent,
        canActivate: [AuthGuardService],
    },
];

@NgModule({
    imports: [
        CommonModule,
        RouterModule.forChild(liveLessonModeratorFeatureShellRoutes),
        EffectsModule.forFeature([
            LiveLessonModeratorAuthEffects,
        ]),

        LiveLessonSharedFeatureShellModule,
    ],
    providers: [
        provideAppInitializer(() => {
            const videoPlayerConfig = inject(VideoPlayerConfigService);
            const savedVolume = videoPlayerConfig.getVolume();

            // this will set the default valume to 0,
            // but only if the volume has not been set previously
            // -> remain the volume across page refreshed
            if (!savedVolume) {
                videoPlayerConfig.setVolume(0);
            }
        }),
    ],
})
export class LiveLessonModeratorFeatureShellModule {
}
